import { FilterFamily } from 'types/generated/graphql';

export function isFilterFamilty(filters: unknown): filters is FilterFamily {
    return (filters as FilterFamily).subFilters !== undefined;
}
